import { StrollrEventType } from '@enums/strollr-event-type.enum';

interface StrollrUserProperty {
  [key: string]: any;
}

const track = (eventName: StrollrEventType) => {
  window?.Strollr?.track({ customEvents: [eventName] });
};

const trackMultiple = (eventNames: StrollrEventType[]) => {
  window?.Strollr?.track({ customEvents: eventNames });
};

const trackUserProperty = (property: StrollrUserProperty) => {
  window?.Strollr?.track({ userProperties: property });
};

const StrollEventService = {
  track,
  trackMultiple,
  trackUserProperty,
};

export default StrollEventService;
